module.exports = __webpack_public_path__ + "static/media/grey-background-3x.eed04603.jpg";